import { mapGenerationFieldError } from "./generationTools";
import { humanizeGenerationErrorMessage } from "./pydanticErrorMessage";

function parseStructuredValidationDetail(detail) {
  if (!detail || typeof detail !== "object" || Array.isArray(detail)) {
    return null;
  }

  if (!Array.isArray(detail.errors) || detail.errors.length === 0) {
    return null;
  }

  return {
    code: detail.code ?? "VALIDATION_FAILED",
    message: detail.message ?? "Request validation failed.",
    errors: detail.errors
      .filter((item) => item && typeof item === "object")
      .map((item) => ({
        field: String(item.field ?? ""),
        code: String(item.code ?? "INVALID"),
        message: String(item.message ?? "Invalid value."),
      }))
      .filter((item) => item.field),
  };
}

function parseFastApiValidationArray(detail) {
  if (!Array.isArray(detail) || detail.length === 0) {
    return null;
  }

  const errors = detail
    .map((item) => {
      if (!item || typeof item !== "object") {
        return null;
      }

      const loc = item.loc;
      const field = Array.isArray(loc) ? loc[loc.length - 1] : null;
      if (field == null || field === "") {
        return null;
      }

      const fieldName = String(field);
      const rawMessage = String(item.msg ?? "Invalid value.");
      const message =
        humanizeGenerationErrorMessage(`${fieldName}: ${rawMessage}`, rawMessage) ??
        rawMessage;

      return {
        field: fieldName,
        code: "INVALID",
        message,
      };
    })
    .filter(Boolean);

  if (errors.length === 0) {
    return null;
  }

  return {
    code: "VALIDATION_FAILED",
    message: "Request validation failed.",
    errors,
  };
}

export function parseValidationDetail(detail) {
  return parseStructuredValidationDetail(detail) ?? parseFastApiValidationArray(detail);
}

export function mapApiErrorsToUi(toolId, validationDetail, mapField = mapGenerationFieldError) {
  const mapped = {};

  for (const item of validationDetail.errors) {
    const uiField = mapField(toolId, item.field);
    mapped[uiField] = {
      field: uiField,
      code: item.code,
      message: item.message,
    };
  }

  return mapped;
}
